import React from "react";
import { OverlayTrigger, Tooltip as BootstrapTooltip } from "react-bootstrap";
import "./DisabledItemNotification.css";

/**
 * DisabledItemNotification
 * Wraps any control and displays a tooltip when disabled.
 * Props:
 * - isDisabled: function or boolean, determines if the child should be disabled
 * - tooltip: string or React node, content for the tooltip
 * - children: the control to wrap (should accept 'disabled' prop if applicable)
 * - placement: tooltip placement (default: 'top')
 * - className: optional extra class for the wrapper
 */
const DisabledItemNotification = ({
  isDisabled,
  tooltip,
  children,
  placement = "top",
  className = "",
}) => {
  // Support function or boolean for isDisabled
  const disabled =
    typeof isDisabled === "function" ? isDisabled() : !!isDisabled;

  // Clone the child and set disabled if possible
  const childWithDisabled = React.isValidElement(children)
    ? React.cloneElement(children, {
        // Only set disabled and pointerEvents if disabled is true
        ...(disabled
          ? {
              disabled: true,
              style: {
                ...(children.props.style || {}),
                pointerEvents: "none",
              },
            }
          : {}),
      })
    : children;

  if (!disabled) {
    // If not disabled, return the original children (not cloned)
    return children;
  }
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <BootstrapTooltip
          id="tooltip-disabled-item-notification"
          className="disabled-item-tooltip"
        >
          {tooltip}
        </BootstrapTooltip>
      }
    >
      <span
        className={`d-inline-block disabled-item-notification-wrapper ${className}`}
        style={{ width: "100%" }}
      >
        {childWithDisabled}
      </span>
    </OverlayTrigger>
  );
};

export default DisabledItemNotification;
